import {makeStyles} from '@material-ui/core/styles';
import {graphSettings} from '../helpers/configs';

const fallbackMain = graphSettings.wrapperHeight;
const fallbackSticky = graphSettings.wrapperHeightSticky;

export const useStyles = makeStyles(theme => ({
  domainImage: {
    height: 18,
    width: 18,
    position: 'relative',
    top: -1,
  },
  sourceRow: {borderBottom: `1px solid #7979793b`, paddingBottom: 4, marginTop: 4, marginBottom: 4},
  noHoverButton: {
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
  graphWrapper: props => {
    const h = props?.wrapperHeight ?? fallbackMain;
    return {
      position: 'relative',
      height: h,
      width: '100%',
      marginBottom: 30, // Add spacing between graph and table (replaces table marginTop)
    };
  },
  chartContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  graph: props => {
    const h = props?.wrapperHeight ?? fallbackMain;
    return {
      width: '100%',
      height: h,
      position: 'absolute',
      // NOTE: intentionally no `transform` here. A transform creates a stacking context that traps
      // AmCharts' tooltip (an absolutely-positioned `.amcharts-balloon-div`) inside the chart, so it
      // could never paint above the change-log badge overlay. Without it, the balloon's z-index
      // (see index.css `.amcharts-balloon-div`) wins over the badges.
    };
  },
  graphUngrouped: props => {
    const h = props?.wrapperHeight ?? fallbackMain;
    return {
      width: '100%',
      height: h / 2,
      position: 'absolute',
      bottom: 0,
    };
  },
  // NOTE: sticky charts are `absolute` inside `fixedPositionWrapper` (which is fixed), NOT
  // `fixed` themselves. A fixed element creates its own stacking context, which would trap the
  // AmCharts tooltip (z-index lift in index.css) below the change-log badge overlay.
  fixedPositionGraph: props => {
    const h = props?.wrapperHeightSticky ?? fallbackSticky;
    return {
      height: h,
      position: 'absolute',
      bottom: 0,
      marginBottom: 35,
      transition: 'all 0.3s ease-in-out',
    };
  },
  fixedPositionGraphUngrouped: props => {
    const h = props?.wrapperHeightSticky ?? fallbackSticky;
    return {
      height: h / 2,
      position: 'absolute',
      bottom: 0,
      marginBottom: 35,
      transition: 'all 0.3s ease-in-out',
    };
  },
  fixedPositionWrapper: props => {
    const h = props?.wrapperHeightSticky ?? fallbackSticky;
    return {
      height: h,
      position: 'fixed',
      bottom: 0,
      background: `linear-gradient(
    to bottom,
    transparent 0%,
    ${theme.palette.background.default} 50%
  )`,
      zIndex: theme.zIndex.appBar,
      transition: 'all 0.3s ease-in-out',
    };
  },
  table: {borderRadius: 4, marginTop: 0, marginBottom: 20},
  tableContainerScroll: {
    overflow: 'scroll',
  },
  tableContainerHidden: {
    overflow: 'hidden',
  },
}));
